import { CabinBagsEnum } from 'enums';

export const PillTypes: Record<string, string> = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};

type PillType = keyof typeof PillTypes;

export const carrierPropertiesTypeMap: Record<string, string> = {
  [CabinBagsEnum.SMALL_BAG]: 'smallBag',
  [CabinBagsEnum.CABIN_BAG]: 'cabinBag',
};

export const BOARDING_OPTIONS_SPECS: string[] = [
  'cabinBags.service1.name.mobile',
  'cabinBags.service2.name.mobile',
  'cabinBags.service3.name.mobile',
  'cabinBags.service4.name.mobile',
  'cabinBags.service3.description',
];

export const BOARDING_OPTIONS_SPECS_BAGS_NAMING_CLEANUP: string[] = [
  'cabinBags.service1.name.alias.mobile',
  'cabinBags.service2.name.alias.mobile',
  'cabinBags.service3.name.alias.mobile',
  'cabinBags.service4.name.mobile',
  'cabinBags.service3.description',
];

export const IconNames: Record<string, string> = {
  SMALL_BIG: 'Baggage-Small-Big',
  SMALL: 'Baggage-Small',
  CHECKIN: 'Baggage-Check-In',
};

export type IconName = keyof typeof IconNames;

interface BoardingOptionProps {
  type: string;
  options: Record<number, boolean>;
  title: string;
  size: string;
  iconName: IconName;
  pill?: {
    text: string;
    variant: PillType;
  };
  isDisabled: boolean;
}

export const getBoardingOptions = (
  isHideThirdOptionEnabled: boolean = false,
  isBagsNamingCleanupEnabled: boolean = false
): BoardingOptionProps[] => [
  {
    type: CabinBagsEnum.CABIN_BAG,
    options: { 0: true, 1: true, 3: true },
    title: isBagsNamingCleanupEnabled
      ? 'cabinBags.cabinBag.alias.title'
      : 'cabinBags.cabinBag.title',
    size: 'cabinBags.cabinBag.size',
    iconName: IconNames.SMALL_BIG,
    pill: isHideThirdOptionEnabled
      ? {
          text: 'cabinBags.warning.likely',
          variant: PillTypes.NEGATIVE,
        }
      : {
          text: 'cabinBags.most.popular',
          variant: PillTypes.POSITIVE,
        },
    isDisabled: false,
  },
  {
    type: CabinBagsEnum.SMALL_BAG,
    options: isHideThirdOptionEnabled
      ? { 0: true, 1: false, 3: false }
      : { 0: true, 1: false, 2: false, 3: false },
    title: isBagsNamingCleanupEnabled
      ? 'cabinBags.smallBag.alias.title'
      : 'cabinBags.smallBag.title',
    size: 'cabinBags.smallBag.size',
    iconName: IconNames.SMALL,
    isDisabled: false,
  },
  ...(!isHideThirdOptionEnabled
    ? [
        {
          type: CabinBagsEnum.HAND_BAG,
          options: { 0: true, 4: true },
          title: isBagsNamingCleanupEnabled
            ? 'cabinBags.handBag.alias.title'
            : 'cabinBags.handBag.title',
          size: 'cabinBags.handBag.size',
          iconName: IconNames.CHECKIN,
          isDisabled: true,
        },
      ]
    : []),
];

export const SMALL_BAG_AMOUNT: number = 0;
